// THE MATERIAL SHEET A SOLUTION IS MADE ON -- its name and size, e.g. "B2 500mm X 707mm". Resolved to the
// viewer's locale and unit from the sheet's stored description columns (the same value LayoutDimension
// #description(unit:) returns server-side), falling back to mm for a sheet that carries no column for the chosen
// unit.
//
// WHICH sheet that is depends on the solution's strategy, which is why this is a shared function and not a field
// to read. For the FOLDING strategy the solution's own material_layout_dimension IS the real board, so it names
// it. For the WITHOUT-FOLDING strategy (carton_lamination, corrugated/flexo) that field holds the
// unconstrained-sheet marker -- LayoutDimension::UNCONSTRAINED_SHEET_MM, the 100,000,000mm dummy board
// SolutionFinderWithoutFolding#large_dummy_dimension installs -- and the REAL board, used as delivered, is the
// die-cutting layout instead.
//
// Which strategy it is comes from `solution_without_folding`, the flag the SAME finder sets on the solution,
// rather than from comparing the width against a copy of the marker's size: the flag and the board are set
// together server-side, so the flag cannot drift out of step with it, whereas a duplicated literal silently could
// (the PR #5230 failure mode).
//
// Null when there is no sheet to name, so a caller draws nothing rather than an empty label.
export const materialSheetLabel = (diecuttingResult, materialLayoutDimension) => {
  const sheet = diecuttingResult && diecuttingResult.solution_without_folding
    ? diecuttingResult.layout_dimension
    : materialLayoutDimension;
  if (!sheet) { return null; }

  const locale = window.locale === 'en' ? 'en' : 'tr';
  return sheet[`description_${locale}_${window.user_unit}`] || sheet[`description_${locale}_mm`] || null;
};
